import { Component, Input, Self } from '@angular/core';
import { CmsArea } from '@domgen/dgx-fe-cms';
import { GAPage } from '@domgen/dgx-fe-ga';
import { SeoPage } from '@domgen/dgx-fe-seo';
import { ContentComponentService } from '../../services/content-component/content-component.service';
import { EditableArea } from '@magnolia/angular-editor';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
  templateUrl: './content.component.html',
  providers: [ContentComponentService],
  standalone: true,
  imports: [NgIf, EditableArea, AsyncPipe],
})
@GAPage()
@SeoPage()
export class ContentComponent {
  @Input() main!: CmsArea;

  constructor(@Self() readonly cs: ContentComponentService) {}
}
